import React, { useState } from 'react';
import './header.css';

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="hamburger" onClick={toggleMenu}>
        <div className={isOpen ? "bar open" : "bar"}></div>
        <div className={isOpen ? "bar open" : "bar"}></div>
        <div className={isOpen ? "bar open" : "bar"}></div>
      </div>
      <ul className={isOpen ? "nav-links open" : "nav-links"}>
            <li><a href='/about-us'>About Us</a></li>
            {/* <li><a href='#our-team' >Divisions</a></li> */}
            <li><a href='#portfolio' >Projects</a></li>
            <li><a href='#clients' >Our Clients</a></li>
      </ul>
    </nav>
  );
};

export default MobileNav;